<template>
  <div class="m-company-page-content">
    <div class="panel-main">
      <h1>北京一维大成科技有限公司</h1>

      <ul>
        <li>价值观：客户为本 创新成长 合作共赢</li>
        <li>愿&nbsp;&nbsp;&nbsp;&nbsp;景：重塑“互联网+”时代的智能入口<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;做数据驱动的智慧化民生服务提供商</li>
      </ul>
      <p>北京一维大成科技有限公司（简称“一维科技”）成立于2002年，致力于政府民生工程领域的信息化建设。是一家以生物认证和人工智能为技术核心，以大数据分析为支撑，以民生业务为载体的创新型公共服务提供商。</p>
      <p>公司拥有业内领先的自主核心技术和持续提升的研发能力，致力于推动生物识别、人工智能和数据智能化分析等前沿科技与传统行业相结合的应用进程，为人们提供一种更加智能、便捷的生活和工作方式。</p>
      <div class="img-wrapper">
        <img src="../../static/images/company/about-company.png" alt="公司简介" />
      </div>
      <p>一维科技拥有一支由高学历、高素质人才组成的专业团队。核心成员来自于国际商业机器公司、暴风影音、乐视等企业。传统巨匠碰撞互联网新俊，让大家在国际视野的起点上洞察行业及技术发展趋势，紧跟前沿技术，发挥创新能力，树立起行业内以前沿技术带动业务发展的产品创新之路。</p>
      <p>一维科技始终以产品为先，秉持“科技驱动、业务为要、跨界创新”的产品理念，为客户提供生物识别身份认证、职业培训云平台、智慧公共服务平台、智慧医保等系列解决方案。广泛服务于社会保障、公共就业、医疗卫生、教育考试等诸多行业，引领了传统行业的创新之路。</p>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
      }
    },
    components: {
    },
    methods: {
    }
  }
</script>

<style lang="scss">
  @import '../assets/style/base.scss';
  @import '../assets/style/public.scss';

  .m-company-page-content {
    @include c-wrap();
    background: #ffffff;
    border: 1px solid #fff;
    padding-top: .86rem;
    width: 100%;
    h1{
      color: #3b3b3b;
      font-size: .50rem;
      margin-bottom: .60rem;
    }
    ul {
      font-size: .24rem;
      color: #8a8a8a;
      line-height: .48rem;
      margin-bottom: .86rem;
      li{
        margin-bottom: .12rem;
        padding-left: .25rem;
        font-size: .24rem;
        color: #8a8a8a;
        &:before{
          content: '';
          display: inline-block;
          width: .06rem;
          height: .06rem;
          border-radius: 1rem;
          background: #707070;
          float: left;
          margin-left: -.6em;
          position: relative;
          top: .20rem;
        }
      }
    }
    p{
      font-size: .30rem;
      color: #515151;
      line-height: .48rem;
      margin-top: .46rem;
      margin-bottom: .46rem;
    }
    .img-wrapper{
      border-radius: .04rem;
      overflow: hidden;
    }
    img{
      display: block;
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/mobile/CompanyProfile.vue